<template>
  <div class="bb-contact-history">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <div class="bb-contact-history__table">
      <ContactCompanyVisasTable
        :columns="columns"
        :rows="rows"
        :isKey="isKey"
        :sticky="true"
        :copiedItem="copiedUserLink"
        @copy="copyLink"
        @delete="deleteCommunication"
        @save="updateTable"
      />
    </div>
    <div class="bb-button-dashed bb-contact-history__button-add"
         @click="addNewEntry">
      <i class="icon-cross"/>Add new
    </div>
    <Pagination :data="fullInfo" :getQuery="getCommunication" :limit="defLimit" class="bb-pagination"/>
  </div>
</template>

<script>
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import ContactCompanyVisasTable
  from '@/components/Dissemination/Sales/CRM/ContactCompany/ContactCompanyVisas/ContactCompanyVisasTable'
import {contactCommunicationTableColumns} from '@/constants/TablesOptions/contactCommunicationTable'
import ContactCommunicationApi from '@/api/ContactCommunication/api'
import UsersListApi from '@/api/UsersList/api'
import Pagination from '@/components/Main/Pagination/Pagination'
import {findIndex, get} from 'lodash'

export default {
  name: 'ContactCommunication',
  components: {
    LoaderFly,
    ContactCompanyVisasTable,
    Pagination
  },
  data () {
    return {
      loaderRun: false,
      columns: contactCommunicationTableColumns,
      rows: [],
      fullInfo: {},
      currentPage: 1,
      defLimit: 30,
      isKey: 0,
      copiedUserLink : null,
    }
  },
  computed: {
    users: {
      get: function () {
        return this.$store.getters.usersList
      },
      set: function (data) {
        this.$store.dispatch('setUsersList', data)
      }
    },
    companyId () {
      return this.$route.params.company
    },
    contactId () {
      return this.$route.params.id
    },
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    async copyLink(value) {
      await navigator.clipboard.writeText(value);
      this.copiedUserLink = value;
    },
    getUserList () {
      const item = contactCommunicationTableColumns.find((el) => el.prop === 'user')
      if (item.options.length) return
      UsersListApi.getUsersList({})
        .then(({data}) => {
          const { users } = data
          this.users = users
          item.options = users
          this.columns = contactCommunicationTableColumns
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getCommunication ({page}) {
      this.loaderRun = true
      ContactCommunicationApi.getCommunication({
        limit: this.defLimit,
        page: page || this.currentPage,
        client: this.$route.params.id,
        clientCompany: this.companyId
      })
        .then(({data}) => {
          const { clientCommunication, page: newPage, } = data;
          this.currentPage = newPage;
          this.fullInfo = data;

          this.rows = clientCommunication.map(item => ({...item, id: item._id}));
          this.isKey = this.isKey + 1;
          this.loaderRun = false;
        })
        .catch((err) => {
          console.error(err)
          this.loaderRun = false
        })
    },
    deleteCommunication (history) {
      const { id } = history
      const index = findIndex(this.rows, {id: id})
      if (index !== -1) this.rows.splice(index, 1)
      if (!id || id === 'new') return
      ContactCommunicationApi.deleteCommunication(id)
        .then(() => {
          this.getCommunication({})
        })
        .catch((err) => {
          console.error(err)
        })
    },
    addNewEntry () {
      const currentUser = findIndex(this.users, {id: this.userInfo.id})
      const hasNew = findIndex(this.rows, {id: 'new'}) !== -1
      if (hasNew) return
      const communication = {
        id: 'new',
        comment: '',
        date: new Date(),
        user: currentUser !== -1 ? this.users[currentUser] : this.users[0],
        link: ''
      }
      this.rows.unshift(communication)
      this.$emit('scroll-up')
    },
    generateBody (communication) {
      const result = {
        client: this.contactId,
        date: communication.date || new Date(),
        comment: communication.comment || '',
        user: get(communication, 'user._id', ''),
        link: communication.link
      }
      if (communication.id && communication.id !== 'new') result.id = communication.id
      return result
    },
    updateTable (communication) {
      const communicationForSend = this.generateBody(communication);
      const isNew = communication.id === 'new';
      if (!isNew) {
        const { _id } = communication;
        const currentIndex = this.rows.findIndex((el) => el._id === _id);
        this.rows.splice(currentIndex, 1, communication);
      }
      const request = isNew ? ContactCommunicationApi.createCommunication : ContactCommunicationApi.updateCommunication;
      request(communicationForSend)
        .then(() => {
          this.getCommunication({});
        })
        .catch((err) => {
          console.error(err);
        })
    }
  },
  beforeMount () {
    this.getUserList();
    this.getCommunication({});
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../sass/variables";
  @import "../../../../../../sass/mixins";

  .bb-contact-history {
    @include global-font;

    &__table {
      margin: 10px 25px;
    }

    &__button-add {
      position: sticky;
      bottom: 0;
      width: calc(100% - 50px);
      margin: 0 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactCommunication/ContactCommunication.vue